import { Link } from 'react-router-dom';
import { IconPhotoPlus, IconMoodSad } from '@tabler/icons-react';
import { useEvents } from '../hooks/useEvents.ts';
import { EventCard } from '../components/gallery/EventCard.tsx';
import { SkeletonGrid } from '../components/ui/Skeleton.tsx';
import { EmptyState } from '../components/ui/EmptyState.tsx';
import { Button } from '../components/ui/Button.tsx';
import { UNCATEGORIZED_EVENT } from '../config/awsConfig.ts';

export function EventsPage() {
  const { data: events, isLoading, isError, error, refetch } = useEvents();

  const sorted = [...(events ?? [])].sort((a, b) => {
    // Uncategorized always last; the rest alphabetical.
    if (a.name === UNCATEGORIZED_EVENT) return 1;
    if (b.name === UNCATEGORIZED_EVENT) return -1;
    return a.name.localeCompare(b.name);
  });

  return (
    <div className="space-y-6">
      <div className="flex items-end justify-between">
        <div>
          <h1 className="text-2xl font-bold text-fg">Events</h1>
          <p className="mt-1 text-sm text-fg-2">
            Browse photos by event, or add your own.
          </p>
        </div>
        <Link to="/upload">
          <Button variant="primary">
            <IconPhotoPlus className="h-5 w-5" /> Upload
          </Button>
        </Link>
      </div>

      {isLoading && <SkeletonGrid count={8} columnsClass="grid-cols-2 md:grid-cols-3 lg:grid-cols-4" />}

      {isError && (
        <EmptyState
          icon={IconMoodSad}
          title="Couldn't load events"
          description={error instanceof Error ? error.message : 'Please try again.'}
          action={
            <Button variant="primary" onClick={() => refetch()}>
              Retry
            </Button>
          }
        />
      )}

      {!isLoading && !isError && sorted.length === 0 && (
        <EmptyState
          icon={IconPhotoPlus}
          title="No photos yet"
          description="Upload your first photos to start an event."
          action={
            <Link to="/upload">
              <Button variant="primary">Upload photos</Button>
            </Link>
          }
        />
      )}

      {sorted.length > 0 && (
        <div className="grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-4">
          {sorted.map((event, i) => (
            <EventCard key={event.name} event={event} index={i} />
          ))}
        </div>
      )}
    </div>
  );
}
